import _ from 'lodash';
export default class DrawLines {
  constructor() {
    this.canvasWidth = 0;
    this.canvasHeight = 0;
    this.canvas = undefined;
    this.config = {};
    this.context = undefined;
    this.frameId = null;
    this.currentPoint = {
      x: null, //当前鼠标x
      y: null, //当前鼠标y
      max: 20000,
    };
    this.randomLines = [];
    this.init();
  }
  init() {
    this.config = this.getConfigOption();
    this.canvas = document.createElement('canvas'); //画布
    this.canvas.id = 'c_n' + this.config.l; //canvas id
    this.context = this.canvas.getContext('2d');
    this.canvas.style.cssText = 'position:fixed;top:0;left:0;z-index:' + this.config.z + ';opacity:' + this.config.o;
    // this.getByTagname('body')[0].appendChild(this.canvas);
    this.getByClassName('login')[0].appendChild(this.canvas);
    this.setCanvasSize();
    let randomLines = [],
      random = Math.random;
    for (let i = 0; this.config.n > i; i++) {
      let x = random() * this.canvasWidth, //随机位置
        y = random() * this.canvasHeight,
        xa = 2 * random() - 1, //随机运动方向
        ya = 2 * random() - 1;
      randomLines.push({
        x: x,
        y: y,
        xa: xa,
        ya: ya,
        max: 12000, //沾附距离
      });
    }
    this.randomLines = randomLines;
    setTimeout(() => this.drawCanvas(), 500);
  }
  destroy() {
    this.canvasWidth = 0;
    this.canvasHeight = 0;
    this.canvas = undefined;
    this.config = {};
    this.context = undefined;
    this.currentPoint = null;
    this.randomLines = [];
    window.cancelAnimationFrame(this.frameId);
  }
  //封装方法，压缩之后减少文件大小
  getAttribute(node, attr, defaultValue) {
    return node.getAttribute(attr) || defaultValue;
  }
  //封装方法，压缩之后减少文件大小
  getByTagname(name) {
    return document.getElementsByTagName(name);
  }
  //封装方法，压缩之后减少文件大小
  getByClassName(name) {
    return document.getElementsByClassName(name);
  }
  getConfigOption() {
    let scripts = this.getByTagname('script'),
      scriptLen = scripts.length,
      script = scripts[scriptLen - 1]; //当前加载的script
    return {
      l: scriptLen, //长度，用于生成id用
      z: this.getAttribute(script, 'zIndex', 1), //z-index
      o: this.getAttribute(script, 'opacity', 1), //opacity
      c: this.getAttribute(script, 'color', '117,142,178'), //color
      n: this.getAttribute(script, 'count', 200), //count
    };
  }
  //重置大小
  setCanvasSize() {
    this.canvasWidth = this.canvas.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.canvasHeight = this.canvas.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  }
  //绘制过程
  drawCanvas() {
    let context = this.context,
      canvasWidth = this.canvasWidth,
      canvasHeight = this.canvasHeight;
    context.clearRect(0, 0, canvasWidth, canvasHeight);
    //随机的线条和当前位置联合数组
    let allArray = [this.currentPoint].concat(this.randomLines);
    let e, i, d, xDist, yDist, dist; //临时节点
    //遍历处理每一个点
    this.randomLines.forEach(r => {
      (r.x += r.xa),
        (r.y += r.ya), //移动
        (r.xa *= r.x > canvasWidth || r.x < 0 ? -1 : 1),
        (r.ya *= r.y > canvasHeight || r.y < 0 ? -1 : 1), //碰到边界，反向反弹
        context.fillRect(r.x - 0.5, r.y - 0.5, 1, 1); //绘制一个宽高为1的点
      for (i = 0; i < allArray.length; i++) {
        e = allArray[i];
        //不是当前点
        if (r !== e && null !== e.x && null !== e.y) {
          (xDist = r.x - e.x), //x轴距离 l
            (yDist = r.y - e.y), //y轴距离 n
            (dist = xDist * xDist + yDist * yDist); //总距离, m
          dist < e.max &&
            (e === this.currentPoint && dist >= e.max / 2 && ((r.x -= 0.03 * xDist), (r.y -= 0.03 * yDist)), //靠近的时候加速
            (d = (e.max - dist) / e.max),
            context.beginPath(),
            (context.lineWidth = d),
            (context.strokeStyle = 'rgba(' + this.config.c + ',' + d + ')'),
            (context.fillStyle = 'rgba(' + this.config.c + ',' + d + ')'),
            context.moveTo(r.x, r.y),
            context.lineTo(e.x, e.y),
            context.stroke());
        }
      }
      allArray.splice(allArray.indexOf(r), 1);
    });
    this.frameId = window.requestAnimationFrame(_.debounce(this.drawCanvas.bind(this), 30));
    // frame_func(drawCanvas);
  }
}
